import { FormControl, Menu, MenuItem, Button } from "@mui/material";
import React, { useEffect, useState, Dispatch, SetStateAction } from "react";
import { useSelector } from "react-redux";
import { selectPublicAnnonces } from "../../store/annonceSlice";
import Slider from "@mui/material/Slider";

type Props = {
  surface: number[];
  setSurface: Dispatch<SetStateAction<number[]>>;
};

const Surface = ({ surface, setSurface }: Props) => {
  const annonces = useSelector(selectPublicAnnonces);
  const [maxSurface, setMaxSurface] = useState(100);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  useEffect(() => {
    let max = 0;
    annonces.forEach((annonce) => {
      if (annonce.data.data.informations.surface.data > max) {
        max = annonce.data.data.informations.surface.data;
      }
    });
    setMaxSurface(max);
  }, [annonces]);

  useEffect(() => {
    console.log(maxSurface);
    setSurface((state) => [state[0], maxSurface]);
  }, [maxSurface]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: Event, newValue: number | number[]) => {
    setSurface(newValue as number[]);
  };

  return (
    <FormControl sx={{ width: { xs: "100%", md: 220 } }}>
      <Button
        onClick={handleClick}
        disableRipple={true}
        size="small"
        sx={{
          height: { xs: 40, md: 40 },
          backgroundColor: "white",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: !!!anchorEl ? "#0000003b" : "primary",
          borderRadius: "4px",
          "&:hover": {
            borderColor: "#000",
            backgroundColor: "white",
          },
          justifyContent: "flex-start",
          padding: { xs: "8px 12px", md: "8px 14px" },
          color: "#00000099",
          fontWeight: "500",
          fontSize: { xs: "0.8rem", md: "0.875rem" },
        }}
      >
        Surface : {Intl.NumberFormat("fr-FR").format(surface[0])}m² -{" "}
        {Intl.NumberFormat("fr-FR").format(surface[1])}m²
      </Button>

      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={handleClose}>
        <MenuItem
          disableRipple={true}
          disableTouchRipple={true}
          sx={{
            minWidth: "300px",
            "&:hover": {
              backgroundColor: "transparent",
            },
            cursor: "default",
          }}
        >
          <Slider
            value={surface}
            onChange={handleChange}
            valueLabelDisplay="on"
            max={maxSurface}
            min={0}
            step={1}
            sx={{ width: "85%", mt: 5, ml: 2 }}
          />
        </MenuItem>
      </Menu>
    </FormControl>
  );
};

export default Surface;
